import { Directive, EventEmitter, HostBinding, HostListener, inject, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AlertDialogService } from '../../services/alert-dialog/alert-dialog.service';

@Directive({
  selector: '[workUiDnd]',
  standalone: true,
})
export class DndDirective {
  @HostBinding('class.file-over') fileOver = false;
  @Input() multiple = false;
  @Input() accept: string[] = [];
  @Output() fileDropped = new EventEmitter<any>();
  private readonly alertDialogService = inject(AlertDialogService);
  private readonly translateService = inject(TranslateService);

  // Dragover listener
  @HostListener('dragover', ['$event']) onDragOver(evt: any) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = true;
  }

  // Dragleave listener
  @HostListener('dragleave', ['$event'])
  public onDragLeave(evt: any) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = false;
  }

  // Drop listener
  @HostListener('drop', ['$event'])
  public ondrop(evt: any) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = false;
    const files = [];
    for (const file of evt.dataTransfer.files) {
      if (this.hasValidSuffix(file.name)) {
        files.push(file);
      }
    }
    if (!files.length) {
      this.alertDialogService.showAlert({
        title: 'UNERLAUBTE_DATEITYPEN',
        message: this.translateService.instant('ERLAUBTE_DATEITYPEN_X', { types: this.accept.join(', ') }),
        feedbackState: 'error',
      });
      return;
    }
    if (!this.multiple && files.length > 1) {
      this.alertDialogService.showAlert({ title: 'NUR_EINE_DATEI_ERLAUBT', feedbackState: 'error' });
    } else if (files.length > 0) {
      this.fileDropped.emit(files);
    }
  }

  private hasValidSuffix(filename: string): boolean {
    return this.accept.some((suffix) => filename.toLowerCase().endsWith(suffix.toLowerCase()));
  }
}
